/* State the fact, then the action (FOUNDATIONS 04). tone is a closed set,
 * not an open string, so a caller can't invent a fourth colour.
 */
import type { ReactNode } from "react";

export function Notice({ children, tone = "info" }: { children: ReactNode; tone?: "info" | "warning" | "error" }) {
  const toneClass = tone === "info" ? "" : `notice--${tone}`;
  return (
    <p className={["notice", toneClass].filter(Boolean).join(" ")} role={tone === "error" ? "alert" : "status"}>
      {children}
    </p>
  );
}
